import { useIntl } from "react-intl"

export const useFormatDate = (
  { includeTime, options }: { includeTime?: boolean; options?: Intl.DateTimeFormatOptions } = {
    includeTime: false,
    options: undefined,
  }
) => {
  const { locale } = useIntl()

  return function formatDate(date: string | Date) {
    const dateObject = new Date(date)

    return includeTime
      ? dateObject.toLocaleString(locale, options)
      : dateObject.toLocaleDateString(locale, options)
  }
}
